'use client';

import Image from 'next/image';
import Link from 'next/link';
import { getCategorySlugFromName } from '@/lib/category-slugs';

interface Product {
  id: string;
  name: string;
  slug: string;
  image: string;
  price: number;
  category?: string;
}

interface RelatedProductsProps {
  products: Product[];
  currentProductId: string;
}

export function RelatedProducts({ products, currentProductId }: RelatedProductsProps) {
  const filteredProducts = products.filter(product => product.id !== currentProductId);

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h3 className="text-xl font-semibold text-gray-900 mb-6">Benzer Ürünler</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredProducts.map((product) => (
          <Link 
            key={product.id} 
            href={`/urunler/${getCategorySlugFromName(product.category || '') || 'diger'}/${product.slug}`}
            className="group"
          >
            <div className="bg-gray-50 rounded-lg overflow-hidden transition-transform duration-200 group-hover:scale-105">
              <div className="aspect-square relative flex items-center justify-center">
                <Image
                  src={product.image}
                  alt={product.name?.trim() || 'Filiz Kozmetik ürün görseli'}
                  fill
                  className="object-cover object-center"
                />
              </div>
              <div className="p-4">
                <h4 className="text-sm font-medium text-gray-900 mb-2 line-clamp-2">
                  {product.name}
                </h4>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
} 